






import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component
export default class OrderConfirmationB2c extends Vue {
    @Prop()
    protected klarnahtmlsnippet!: string;

    private klarnaHtmlSnippetInternal!: string;

    get klarnahtmlsnippetinternal(): string {
        return this.klarnaHtmlSnippetInternal;
    }

    set klarnahtmlsnippetinternal(value: string) {
        this.klarnaHtmlSnippetInternal = value;
    }

    constructor() {
        super();
        this.klarnahtmlsnippetinternal = this.klarnahtmlsnippet;
    }

    mounted() {
        let klarnaOrdeConfirmationContainer = document.getElementById('klarna-order-confirmation-widget');
        if (klarnaOrdeConfirmationContainer) {
            klarnaOrdeConfirmationContainer.innerHTML = this.klarnahtmlsnippetinternal;
            let scriptsTags = klarnaOrdeConfirmationContainer.getElementsByTagName('script');
            for (let i = 0; i < scriptsTags.length; i++) {
                let parentNode = scriptsTags[i].parentNode;
                let newScriptTag = document.createElement('script');
                newScriptTag.type = 'text/javascript';
                newScriptTag.text = scriptsTags[i].text;
                if (parentNode) {
                    parentNode.removeChild(scriptsTags[i]);
                    parentNode.appendChild(newScriptTag);
                }
            }
        }
    }
}
